import { render, staticRenderFns } from "./TableEditor.vue?vue&type=template&id=382c3141&"
import script from "./TableEditor.vue?vue&type=script&lang=js&"
export * from "./TableEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports